<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { primaryColors, primary, setPrimaryColor } = useLayout()
</script>

<template>
  <div class="w-56 max-w-[calc(100vw-2rem)] rounded-md bg-white p-4 dark:bg-neutral-900">
    <span class="text-sm font-semibold text-muted">{{
      t('pages.user.settings.appearance.primaryColor')
    }}</span>
    <div class="flex flex-wrap gap-2 pt-2 pointer-coarse:gap-2.5">
      <button
        v-for="pc of primaryColors"
        :key="pc.name"
        type="button"
        :title="pc.name"
        class="h-5 w-5 cursor-pointer rounded-full border-none p-0 focus:ring-2 focus:ring-offset-2 focus:outline-none pointer-coarse:h-8 pointer-coarse:w-8"
        :class="[{ 'ring-2 ring-primary ring-offset-2': primary === pc.name }]"
        :style="{ backgroundColor: pc.palette['500'] }"
        @click="setPrimaryColor(pc.name)"
      />
    </div>
  </div>
</template>
